<!--
    Program: ImeiReview.vue
    Author: SDL
    Description: 
    Created: 2020.03.20
-->

<template>
    <!-- contents -->
    <div id="contents">
        <div class="contents_wrap">
            <h2 class="pg_title">{{pageTitle}}</h2>
            <!-- breadcrumbs -->
            <skp-breadcrumbs @page-title="val => (pageTitle = val)" />
            <!-- breadcrumbs -->
            <div>
                <div class="sub_tit">IMEI Review</div>
                <!-- srchTop_wrap -->
                <div class="srchTop_wrap srch_result mb-20" style="padding: 20px !important;">
                    <article class="srch_basic clear">
                        <dl class="dl_search w100p">
                            <dd class="clearable" data-input-type="input">
                                <input
                                    type="tel"
                                    class="text_input w30p"
                                    placeholder="Enter IMEI"
                                    pattern="^[0–9]$"
                                    v-regex="/[^0-9,]/g"
                                    minlength="11"
                                    maxlength="320"
                                    ref="imei"
                                    v-model="imei"
                                    @keyup.enter.stop="onAddImeiClick"
                                />
                                <a
                                    href="javascript:"
                                    class="btn_srch col_white"
                                    @click="onAddImeiClick"
                                >Add</a>
                            </dd>
                            <dd class="btn">
                                <a
                                    href="javascript:"
                                    class="btn_srch"
                                    @click="onSearchClick"
                                >Search</a>
                            </dd>
                        </dl>
                    </article>
                </div>

                <div class="grid_wrap">
                    <div id="grid">
                        <toast-grid
                            gridId="gridImei"
                            :key="gridKey"
                            :data="gridData"
                            :columns="gridColumns"
                            :header="gridHeader"
                            :options="gridOptions"
                            :pageOptions="gridPageOptions"
                            :theme="gridTheme"
                            :isTotalCount="false"
                            v-bind:click="gridItemClick"
                        />
                    </div>
                </div>
                <!--//list table-->
            </div>

            <div style="margin-top: 32px;">
                <psn-review />
            </div>

            <!--//list table-->
            <!-- //breadcrumbs -->
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import qs from 'query-string';
import { SDLUtil, StringUtil, DateUtil } from '@/utils';

import ToastGrid from '~c/ToastGrid';

import { CellHtmlRenderer, HeaderHtmlRenderer, ButtonRenderer } from '~c/GridCustomRenderer';

import SKPBreadcrumbs from '~vb/main/SKPBreadcrumbs';
import PsnReview from '~vb/anysvcmobile/imeiReview/PsnReview';

export default {
    name: 'imeiReview',
    components: {
        'skp-breadcrumbs': SKPBreadcrumbs,
        'toast-grid': ToastGrid,
        'psn-review': PsnReview,
    },
    props: [],
    computed: {},
    data() {
        return {
            pageTitle: '',

            imei: '',

            imeiList: [],
            repetitionImeiList:[],
            unqualifiedImeiList:[],

            // resultCount: 0,

            // currentPage: 1,
            // perPage: parseInt(localStorage.getItem('listRows') || 10),

            gridKey: 0,

            selectedGridDataKey: 0,

            gridData: [],

            gridHeader: {
                // height: 100,
                //complexColumns: []
                columns: [
                    {
                        name: 'export_country',
                        renderer: HeaderHtmlRenderer,
                    },
                    {
                        name: 'validity',
                        renderer: HeaderHtmlRenderer,
                    },
                ],
            },
            gridColumns: [
                {
                    header: 'DELETE',
                    name: 'DELETE',
//                     width: 80,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                    renderer: { type: ButtonRenderer, options: { text: 'Delete' } },
                },
                {
                    header: 'IMEI', // PREFIX = '000' 일 때 CODE_NAME
                    name: 'imei',
//                     width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'MODEL',
                    name: 'model',
//                      width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'SKU',
                    name: 'item',
//                     width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'SERIAL NUMBER',
                    name: 'prod_sn',
//                     width: 140,
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'SHIPPING DATE',
                    name: 'export_date',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'SHIPPING COUNTRY',
                    name: 'export_country',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'BUYER',
                    name: 'buyer',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'PROD.DATE',
                    name: 'prod_date',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
                {
                    header: 'SALES DATE',
                    name: 'sales_date',
                    align: 'center',
                    resizable: false,
                    sortable: false,
                },
//                 {
//                     header: 'Set Info',
//                     name: 'setInfo',
//                     align: 'center',
//                     resizable: false,
//                     sortable: false,
//                 },
//                 {
//                     header: 'Validity<br>(China)',
//                     name: 'validity',
//                     align: 'center',
//                     resizable: false,
//                     sortable: false,
//                 },
            ],
            gridOptions: {
                scrollX: false,
                scrollY: false,
            },
            gridTheme: {
                name: 'skpTheme', // required
                value: {
                    // required
                    row: {
                        hover: {
                            background: '#FBFBFC',
                        },
                    },
                    // cell: {
                    //     normal: {
                    //         background: '#00ff00',
                    //         border: '#e0e0e0'
                    //     },
                    //     head: {
                    //         background: '#ff0000',
                    //         border: '#ffff00'
                    //     },
                    // },
                },
            },
            gridPageOptions: null,
        };
    },
    created() {
        console.log('Component: imeiReview created. ');
    },
    mounted() {
        console.log('Component: imeiReview mounted.');
    },
    methods: {
        onAddImeiClick() {
        	let imeiArr = this.imei.split(",");
        	let notNullimeiArr = [];
        	for(const imei of imeiArr){
        		imei = imei.trim();
        		if(imei.length !== 0){
        			imei = imei.replace(/[^0-9,]/g, '');
        			notNullimeiArr.push(imei);
        		}	
        	}
        	for(const imei of notNullimeiArr ){
        		const success = this.addImei(imei);
               
                this.imei = '';

                window.setTimeout(() => {
                    this.$refs.imei.focus();
                }, 200);
        	} 
        	
        	if(this.unqualifiedImeiList.length > 0 && this.repetitionImeiList.length > 0 ){
        		 SDLUtil.alert({
                     title: 'Invalid Input',
                     msg: 'Unqualified data length IMEI:['+this.unqualifiedImeiList+'];<br>'+'Repetitive IMEI：['+this.repetitionImeiList+']',
                 });
        		 	this.repetitionImeiList=[];
     				this.unqualifiedImeiList=[];
                 return;
        	}
        	
			if(this.unqualifiedImeiList.length > 0  ){
				 SDLUtil.alert({
                     title: 'Invalid Input',
                     msg: 'Unqualified data length IMEI:['+this.unqualifiedImeiList+']',
                 });
				 	this.unqualifiedImeiList=[];
                 return;
        	}
			
			if(this.repetitionImeiList.length > 0  ){
				 SDLUtil.alert({
                     title: 'Invalid Input',
                     msg: 'Repetitive IMEI：['+this.repetitionImeiList+']',
                 });
				 	this.repetitionImeiList=[];
                 return;
        	}
        },

        addImei(imei) {
            imei = String(imei).toUpperCase();
			
            if (imei.length < 10 || imei.length > 15) {                 
            	this.unqualifiedImeiList.push(imei);
            	return false;
            }
            
            if (this.imeiList.find(item => item === imei)) {
            	this.repetitionImeiList.push(imei);
                return false;
            }
            this.gridData.push({
                imei: imei,
            });

            // this.imeiList.push(imei);
            this.imeiList = this.gridData.map(item => item.imei);

            this.gridKey += 1;
            return true;
        },

        async onSearchClick() {
            if (this.imeiList.length === 0) {
                SDLUtil.alert({
                    title: 'Invalid Input',
                    msg: 'Please add IMEI to check',
                });
                return;
            }

            const data = await this.fetchResult();
            if (data == null) return; 
            this.setData(data.result);
        },

        fetchResult() {
            const path = '/basis/anysvcmobile/imeiReview/IMEIReviewSearchAjax.skp';
            const formData = {
                imei: this.imeiList,
            };
            return SDLUtil.postForm(path, formData)
                .catch(err => {
                    SDLUtil.alert({
                        title: 'Server Error',
                        msg: 'Error while getting data from server.',
                    });
                    return null;
                });
        },

        setData(data) {
            this.gridData = this.gridData.map(item => {
                const newData = data.find(dItem => dItem.imei === item.imei);
                if (newData.result === 'E') {
                    newData.model = newData.output;
                }
                return newData;
            })
            // this.gridData = data;

            this.gridKey += 1;
        },

        gridItemClick(e, rows) {
            console.log('selectGridItem', e, rows);
            const rowIdx = e.rowKey;
            // const gridItem = this.gridData[rowIdx];
            if (e.columnName === 'DELETE') {
                this.deleteItem(rowIdx)
            }
        },

        deleteItem(rowIdx) {
            this.gridData = this.gridData.filter(item => item.rowKey !== rowIdx);
            this.imeiList = this.gridData.map(item => item.imei);
            this.gridKey += 1;
        },

    },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/anysvcmobile/imeiReview/ImeiReview.vue